import React, { FC } from 'react';
import * as S from './DesktopFilters.styles';
import { PropertyOption } from '@/api/types/categories.types';
import { QUERY } from '@/constants/common';
import { KeywordsSource } from '@/components/SearchPanel/components/SearchSuggestions.types';

interface Props {
  clearUrl: string;
  baseSearchParams: string;
  option: PropertyOption;
  propertyLegacyId: string;
  value: string | undefined;
  onClick: () => void;
}

export const CollectionDesktopFilterOption: FC<Props> = ({
  clearUrl,
  baseSearchParams,
  option,
  propertyLegacyId,
  value,
  onClick,
}) => {
  function getHref() {
    const searchParams = new URLSearchParams(baseSearchParams);
    searchParams.delete(QUERY.user_id);
    searchParams.set(`p[${propertyLegacyId}]`, option.legacyResourceId);
    searchParams.set(QUERY.keywords_source, KeywordsSource.Typewritten);
    return `${clearUrl}?${searchParams.toString()}`;
  }

  const isActive = option.legacyResourceId.toString() === value;
  return (
    <S.LinkOption
      key={option.name}
      href={getHref()}
      $isActive={isActive}
      onClick={onClick}
    >
      <S.RadioButton $isActive={isActive} />
      <S.LinkOptionText>{option.name}</S.LinkOptionText>
    </S.LinkOption>
  );
};
